"use strict";
import "./libraries/modernizr";

import $ from "jquery";
window.jQuery = window.$ = $;

import "./plugins/cookie";
import "components/card/card";

// карусель
import "slick-carousel";
// модальные окнка и галерея
import "@fancyapps/fancybox";
// маска для телефона
import Cleave from "cleave.js";
require("cleave.js/dist/addons/cleave-phone.ru.js");

import "components/aside/aside";
import "components/nav/nav";
import "components/main/banner/banner";
import "components/main/catalog/catalog";
import "components/product/image/image";
import "components/product/body/body";
import "components/product/feedback/feedback";
import "components/product/related/related";
import "components/modal/modal";
import "components/page/contacts/contacts";

// запуск маски для телефона
$("body").on("focus", ".js-mask-phone", function() {
    var cleave = new Cleave(".js-mask-phone", {
        prefix: "+7",
        delimiters: [" (", ") ", "-"],
        blocks: [2, 3, 3, 2, 2]
    });
});
// убираем с поля для телефона любые символы кроме цифр
$(".js-mask-phone").on("keydown", function(e) {
    if (e.key.length == 1 && e.key.match(/[^0-9'".]/)) {
        return false;
    }
});



// WEBPACK FOOTER //
// ./markup/static/js/main.js